import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogConfigInterface {
  /**
   * Confirmation message to display
   */
  message?: string;

  /**
   * Confirmation message to display (allowing HTML)
   */
  messageHTML?: string;

  /**
   * Whether the send button is disabled or not
   */
  disabledButton?: boolean;

  /**
   * Allow to enable or disable all button
   */
  actionDialog?: boolean;

  /**
   * Allow to enable or disable dismiss button
   */
  actionDismiss?: boolean;

  /**
   * Allow to enable or disable accept button
   */
  actionAccept?: boolean;
}

/**
 * Component selector, template-form and style
 */
@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
/**
 * Confirmation component
 */
export class ConfirmComponent {
  /**
   * Text for the accept button
   */
  public acceptDialog = 'OK';

  /**
   * Text for the dismiss button
   */
  public dismissDialog = 'Cancel';

  /**
   * The label for the reason textarea
   */
  public labelReason = 'Short description';

  /**
   * Config parameters for the confirm dialog itself
   */
  config: ConfirmDialogConfigInterface = {};

  /**
   * Constructor
   * @param dialogRef Material dialog reference
   * @param data Dialog data
   */
  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogConfigInterface
  ) {
    this.config.message = data.message !== undefined ? data.message : '';
    this.config.messageHTML = data.messageHTML !== undefined ? data.messageHTML : '';
    this.config.disabledButton = data.disabledButton !== undefined ? data.disabledButton : false;
    this.config.actionDialog = data.actionDialog !== undefined ? data.actionDialog : true;
    this.config.actionDismiss = data.actionDismiss !== undefined ? data.actionDismiss : true;
    this.config.actionAccept = data.actionAccept !== undefined ? data.actionAccept : true;
  }
}
